import './SocialIcons.css'

const SocialIcons = () => {
  return (
    <ul className="social-icons-list">
        <li>
          <a href="https://soundcloud.com/nessakodo" target="_blank" rel="noopener noreferrer" aria-label="SoundCloud">
            <i className="fab fa-soundcloud"></i>
          </a>
        </li>
        <li>
          <a href="https://youtube.com/@nessakodo" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fab fa-youtube"></i>
          </a>
        </li>
        <li>
          <a href="https://twitch.tv/nessakodo" target="_blank" rel="noopener noreferrer" aria-label="Twitch">
            <i className="fab fa-twitch"></i>
          </a>
        </li>
        <li>
          <a href="https://discord.gg/6xyj2xshxY" target="_blank" rel="noopener noreferrer" aria-label="Discord">
            <i className="fab fa-discord"></i>
          </a>
        </li>
      </ul>
  )
}

export default SocialIcons
